import API from '../api';
import moment from 'moment';

let loadPromise = null;
const api = new API();

/**
 * Метод генерации адреса для загрузки Яндекс.Карт
 * @param {Object} options Объект параметров карты
 */
const generateURL = (options) => {
	const queryString = Object.keys(options).map(key => `${key}=${options[key]}`).join('&');

	return `https://api-maps.yandex.ru/2.1/?${queryString}`;
}

/**
 * Метод асинхронной загрузки скрипта (добавляет тег script в body)
 * @param {String} url 
 */
const fetchScript = (url) => {
	return new Promise ((resolve, reject) => { // eslint-disable-line
		const script = document.createElement('script');
		script.onload = resolve;
		script.onerror = reject;
		script.src = url;

		document.body.appendChild(script);
	});
}

/**
 * Метод загрузки скриптов Яндекс.Карт
 * @param {Object} options Объект параметров карты
 */
export const loadApi = (options) => {
	if (loadPromise) {
		return loadPromise;
	}

	const url = generateURL(options);

	loadPromise = new Promise (resolve => // eslint-disable-line
		fetchScript(url).then(() => { window.ymaps.ready(() => resolve(window.ymaps))})
	);

	return loadPromise;
}

/**
 * Метод парсинга параметров строки
 * @param {string} url
 * @return {object}
 */
export const parseUrl = (url) => {
	const regExp = /[?&]([^=#]+)=([^&#]*)/g;
	const params = {};
	let match = '';

	while (match = regExp.exec(url)) { //eslint-disable-line
		params[match[1]] = match[2];
	}

	return params;
}

export const getFilials = filter => {
	return api.post('/clients/opts', {filter});
}

export const getPmBalloonData = id => {
	return api.post('/clients/placemark-info', {id});
}

export const translateServerError = error => {
	let result = '';
	switch(error) {
		case 'Undefined index: lon':
		case 'Undefined index: lat':
			result = 'Необходимо указать адрес';
			break;
		default:
			result = error;
			break;
	}

	return result;
}

export const formatDate = date => {
	const dateToFormat = date ? moment(date) : moment();
	return dateToFormat.format('DD.MM.YYYY');
}

export const prepareUsersForSelect = users => users.map(user => ({value: user.id, label: user.fio || user.login}));

export const getDepth = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o);

export const createRedirectUrlFromType = (cardId, cardType) =>
{
	switch (cardType) {
		case 1: return `/supplier-detail?id=${cardId}`;
		case 2: return `/client-detail?id=${cardId}`;
		case 3: return `/elevator-detail?id=${cardId}`;
	}
}


// WEBPACK FOOTER //
// ./helpers/core.js